/**
 * Checks if the current user is a demo user by looking for the 'OldUser' key in localStorage
 * This key is set by the legacy host app when a user is in demo mode
 */
export const isDemoUser = (): boolean => {
    try {
        const oldUser = localStorage.getItem('OldUser');
        return !!oldUser;
    } catch {
        return false;
    }
};

/**
 * POST endpoints that use POST for GET semantics (large payload in body)
 * These should be allowed for demo users as they are read operations
 */
const READ_ONLY_POST_ENDPOINTS: string[] = ['/directory/user/byids'];

/**
 * Checks if an HTTP method is NOT a GET request (all non-GET requests should be blocked for demo users)
 * Optional url parameter allows bypassing for read-only POST endpoints
 */
export const isWriteOperation = (method: string, url?: string): boolean => {
    const writeOperations = ['POST', 'PUT', 'DELETE', 'PATCH'];
    const isWriteMethod = writeOperations.includes(method.toUpperCase());

    // If it's a POST request, check if it's a read-only endpoint
    if (isWriteMethod && method.toUpperCase() === 'POST' && url) {
        return !READ_ONLY_POST_ENDPOINTS.some((endpoint) => url.includes(endpoint));
    }

    return isWriteMethod;
};
